import { Trans, useLingui } from '@lingui/react/macro'
import { createFileRoute } from '@tanstack/react-router'
import { IconPlusOutline18 } from 'nucleo-ui-outline-18'
import { LeadKanbanView } from '~/components/funnel/lead-kanban-view'
import { openLeadModal } from '~/components/funnel/lead-modal'
import { OriginBreakdown } from '~/components/funnel/origin-breakdown'
import { Button } from '~/components/ui/button'
import { PageHeader } from '~/components/ui/page-header'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/funnel/')({
  component: FunnelIndex,
})

function FunnelIndex() {
  const { t } = useLingui()

  return (
    <div className="flex h-full flex-col">
      <PageHeader title={t`Funnel`}>
        <Button onClick={() => openLeadModal({})} size="sm" type="button">
          <IconPlusOutline18 />
          <Trans>New lead</Trans>
        </Button>
      </PageHeader>
      <div className="min-h-0 flex-1">
        <LeadKanbanView afterColumns={<OriginBreakdown />} />
      </div>
    </div>
  )
}
